import { CommonModule }        from '@angular/common';
import { NgModule }            from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule }               from '@shared/shared.module';
import { FormUtilitiesModule }        from '@shared/form-utilities/form-utilities.module';
import { PaymentModule }              from '@shared/payment/payment.module';
import { InstitutionalRoutingModule } from './institutional-routing.module';

import { HomeComponent }                 from './home/home.component';
import { ForSchoolsComponent }           from './for-schools/for-schools.component';
import { AboutComponent }                from './about/about.component';
import { ContactComponent }              from './contact/contact.component';
import { TermsOfServiceComponent }       from './terms-of-service/terms-of-service.component';
import { PrivacyComponent }              from './privacy/privacy.component';
import { MarathonRegulationComponent }   from './marathon-regulation/marathon-regulation.component';
import { NewGridAnnouncementComponent }  from './new-grid-announcement/new-grid-announcement.component';
import { TutorialsComponent }            from './tutorials/tutorials.component';
import { ProofreaderApplicantComponent } from './proofreader-candidate/proofreader-applicant.component';


@NgModule(
  {
    declarations: [
      HomeComponent,
      ForSchoolsComponent,
      AboutComponent,
      ContactComponent,
      TermsOfServiceComponent,
      PrivacyComponent,
      MarathonRegulationComponent,
      NewGridAnnouncementComponent,
      ProofreaderApplicantComponent,
      TutorialsComponent
    ],
    imports:      [
      CommonModule,
      ReactiveFormsModule,
      FormUtilitiesModule,
      PaymentModule,
      SharedModule,
      InstitutionalRoutingModule
    ]
  }
)
export class InstitutionalModule {}
